import api from '../../plugins/api';

const editCar = (id, payload) => {
  if (!id) throw new Error('id is required');
  return api.post('/api/crm/cars/edit/' + id, payload);
};

export default editCar;
